import { collectResults } from 'utils/query'
import { getMediaFiles } from '../getMediaFiles'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import Styles from './UploadsDrawer.module.scss'
import { UploadedFile } from '../UploadedFile'
import { Button } from 'blaze-ui/Button'
import { useInfiniteBrandKitMediaFiles } from 'hooks/queries/brandKits/useInfiniteBrandKitMediaFiles'
import { AlmanacFile } from 'types'

interface Props {
  brandKitId: number
}

export const BrandKitPanel = ({ brandKitId }: Props) => {
  const mediaFilesQuery = useInfiniteBrandKitMediaFiles({ brandKitId })
  const brandKitMediaFiles = collectResults(mediaFilesQuery, (data) => data.media_files)
  const mediaFiles = getMediaFiles(brandKitMediaFiles as AlmanacFile[], ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES)

  const { hasNextPage, fetchNextPage } = mediaFilesQuery

  return (
    <div>
      <div className={Styles.sectionContainer}>
        <div className={Styles.groupItems}>
          {mediaFiles.map((file) => (
            <div key={file.id} className={Styles.mediaFileContainer}>
              <UploadedFile file={file} />
            </div>
          ))}
        </div>
      </div>
      {hasNextPage && (
        <div className={Styles.seeMoreButton}>
          <Button fullWidth variant="tertiary" size="lg" onPress={() => fetchNextPage()}>
            See More
          </Button>
        </div>
      )}
    </div>
  )
}
